// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__1mple","calendarButtons":"ClockData_calendarButtons__Kr7l8"};